import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HttpModule} from "@angular/http";

import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {CalendarModule, DateAdapter} from "angular-calendar";
import {adapterFactory} from "angular-calendar/date-adapters/date-fns";
import {NgbModalModule} from "@ng-bootstrap/ng-bootstrap";
import {OwlDateTimeModule, OwlNativeDateTimeModule} from "ng-pick-datetime";

import {HomeComponent} from "./home/home.component";
import {CoreRoutingModule} from "./core-routing.module";
// import { LeadsListComponent } from './leads-list/leads-list.component';
import {AddLeadDialogComponent} from "../shared/add-lead-dialog/add-lead-dialog.component";
import {AddNewEventDialogComponent} from "../shared/add-new-event-dialog/add-new-event-dialog.component";
import {AddFileDialogComponent} from "../shared/add-file-dialog/add-file-dialog.component";
import {AddProjectDialogComponent} from "../shared/add-project-dialog/add-project-dialog.component";
import {ProjectDetailComponent} from "./projects/project-detail/project-detail.component";

import {
  MatExpansionModule,
  MatButtonModule,
  MatDatepickerModule,
  MatInputModule,
  MatNativeDateModule,
} from "@angular/material";

import {ProjectListComponent} from "./projects/project-list-old/project-list.component";
import {CalendarComponent} from "./calendar/calendar.component";
import {EditProjectDialogComponent} from "./projects/edit-project-dialog/edit-project-dialog.component";
import {ShowCalenderEventsDialogComponent} from "./show-calender-events-dialog/show-calender-events-dialog.component";
import {EditProfileComponent} from "./edit-profile/edit-profile.component";
import {ContactsListComponent} from "./contacts/contacts-list/contacts-list.component";
import {EditContactDialogComponent} from "./contacts/edit-contact-dialog/edit-contact-dialog.component";
import {FilesListComponent} from "./files-list/files-list.component";

import {AddAppointmentDialogComponent} from "../shared/add-appointment-dialog/add-appointment-dialog.component";
import {AddReminderDialogComponent} from "../shared/add-reminder-dialog/add-reminder-dialog.component";
import {AddNoteDialogComponent} from "../shared/add-note-dialog/add-note-dialog.component";
import {ProjectMapFilesDialogComponent} from "../shared/project-map-files-dialog/project-map-files-dialog.component";
import {SharedModule} from "../shared/shared.module";
import {ContactDetailComponent} from "./contacts/contact-detail/contact-detail.component";
import {ScheduleWalkThroughDialogComponent} from "./projects/schedule-walk-through-dialog/schedule-walk-through-dialog.component";
import {RequestDeliveryDialogComponent} from "./projects/request-delivery-dialog/request-delivery-dialog.component";
import {SendToProductionDialogComponent} from "./projects/send-to-production-dialog/send-to-production-dialog.component";

import {PmfdlComponent} from "./projects/pmfdl/pmfdl.component";
import {SigninsListComponent} from "./signins/signins-list/signins-list.component";
import {ClaimSigninComponent} from "./signins/claim-signin/claim-signin.component";
import {TabListComponent} from "../shared/tab-list/tab-list.component";
import {ProjectList2Component} from "./projects/project-list2/project-list2.component";
import {NodeComponent} from "./node/node.component";
import {ClaimMarketingListEntryComponent} from "./claim-marketing-list-entry/claim-marketing-list-entry.component";
import {EditReminderDialogComponent} from "../shared/edit-reminder-dialog/edit-reminder-dialog.component";

@NgModule({
  declarations: [
    HomeComponent,
    ProjectListComponent,
    CalendarComponent,
    EditProjectDialogComponent,
    ShowCalenderEventsDialogComponent,
    EditProfileComponent,
    ContactsListComponent,
    EditContactDialogComponent,
    FilesListComponent,
    ProjectDetailComponent,
    ContactDetailComponent,
    ScheduleWalkThroughDialogComponent,
    RequestDeliveryDialogComponent,
    SendToProductionDialogComponent,
    PmfdlComponent,
    SigninsListComponent,
    ClaimSigninComponent,
    ProjectList2Component,
    NodeComponent,
    ClaimMarketingListEntryComponent,
  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    MatExpansionModule,
    MatButtonModule,
    MatDialogModule,
    NgbModalModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SharedModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  entryComponents: [
    AddLeadDialogComponent,
    AddNewEventDialogComponent,
    AddFileDialogComponent,
    AddProjectDialogComponent,
    EditProjectDialogComponent,
    ShowCalenderEventsDialogComponent,
    EditContactDialogComponent,
    AddAppointmentDialogComponent,
    AddReminderDialogComponent,
    AddNoteDialogComponent,
    ScheduleWalkThroughDialogComponent,
    RequestDeliveryDialogComponent,
    SendToProductionDialogComponent,
    ProjectMapFilesDialogComponent,
    TabListComponent,
    EditReminderDialogComponent,
  ],
  providers: [{provide: MatDialogRef}],
})
export class CoreModule {}
